<template>
  <div style="text-align: left">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" :title="dialogTitle"
               :append-to-body="true" :modal-append-to-body="true" width="1200px">
      <el-row :gutter="15">
        <el-col :span="16">
          <ContractAnnexes ref="refContractAnnexes" :current-row="currentRow" :up-file-list="upFileList"
                           @upFileListDel="upFileListDel"/>
        </el-col>
        <el-col :span="8" style="border-left: #9F9F9F dashed 1px;height: 300px">
          <div>
            <span style="font-size:12px;font-weight: 800">文件上传： 需求表/合同</span>
          </div>
          <div>
            <el-upload
                class="upload-demo"
                action="/api/upload/file_uploader"
                :headers="header"
                name="upload_file"
                :data="uploadData"
                :on-remove="handleRemove"
                :file-list="fileList"
                :on-change="handleChange"
                :on-success="handleSuccess"
                drag
                multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">支持的文件格式：压缩包或jpg、png、pdf、word 大小:5 M</div>
            </el-upload>

          </div>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="saveBtn" :disabled="saveLoading" :loading="saveLoading">确 定</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {mTofixed} from "@/views/adOrder/index";
import {delContractAnnex, saveContractAnnexes} from "@/api/adOrder";
import ContractAnnexes from "@/views/contract/ContractAnnexes";

export default {
  name: "UploadFile",
  components: {ContractAnnexes},
  computed: {
    dialogTitle() {
      return `上传 - 合同（${this.currentRow.contract_no}）附件`;
    }
  },
  props: {
    currentRow: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      loadingCommit: false,
      saveLoading: false,
      upFileList: [],
      fileList: [],
      // 附件类型
      allowTypeList: ['application/pdf', 'application/caj', '', 'application/zip', 'application/rar', 'application/doc'],
      allowSize: 1024 * 1024 * 5,
      header: {},
      uploadData: {file_type: 'annex', folder: 'attachments'}
    }
  },
  methods: {
    onOpen() {
      this.upFileList = []
      this.fileList = []
      this.saveLoading = false
    },
    onClose() {
      // this.$refs['elForm'].resetFields()
      this.$emit('refreshData')
    },
    close() {
      this.$emit('update:visible', false)
    },
    /**
     * 上传前
     */
    async beforeUpload(file) {
      // console.log(file)
      let checkType = this.allowTypeList.indexOf(file.type)
      let checkSize = file.size > this.allowSize

      if (checkType < 0) {
        this.$message.error('文件类型不合法')
        throw '文件类型不合法'
      }
      if (checkSize) {
        this.$message.error('文件大小超过限制')
        throw '文件大小超过限制'
      }
      const suffix_index = file.name.lastIndexOf(".")
      this.fileType = file.name.substring(suffix_index)
      //上传配置
      await this.setOssParams()
      await this.$emit('handleUploadBefore', file)
      return true
    },

    // 文件大小单位
    fileSizeName(size) {
      if (size < 1024) {
        return size + ' ' + 'bit'
      } else if (size >= 1024 && size < (1024 * 1024)) {
        return mTofixed((size * 0.001), 2) + ' ' + 'kB'
      } else if (size >= (1024 * 1024)) {
        return mTofixed((size * 0.001 * 0.001), 2) + ' ' + 'MB'
      }
    },
    // eslint-disable-next-line
    handleSuccess(response, file, fileList) {
      if (response.success) {
        this.fileList.push(file)
        // eslint-disable-next-line
        let model = response.model;
        let item = {
          name: model['title'],
          size: model['size'],
          file_path: response['file_path'],
          file_id: model['id'],
          contract_id: this.currentRow.id
        }
        this.upFileList.push(item)

      } else {
        this.$message.warning(response.message)
      }
    },
    // eslint-disable-next-line
    handleRemove(file, fileList) {
      // eslint-disable-next-line
      let index = this.fileList.indexOf(file)
      if (index > -1)
        this.fileList.splice(index, 1)
    },
    handlePreview(file) {
      // eslint-disable-next-line
      console.log(file);
    },
    // eslint-disable-next-line
    handleChange(file, fileList) {
      // this.fileList.push(file)
    },
    //下载文件
    // eslint-disable-next-line
    downLoadFile(url, name) {
      //
      this.FileSaver.saveAs(url, name)
    },
    async upFileListDel(index, id) {
      if (id) {
        this.$msgbox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await delContractAnnex({id: id})
          this.upFileList.splice(index, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      } else {
        this.upFileList.splice(index, 1)
      }
    },
    async saveBtn() {
      this.saveLoading = true
      let data = {
        items: this.upFileList
      }
      let {info} = await saveContractAnnexes(data).then((res) => {
        return res.data
      })
      if (info === 'ok') {
        this.$notify.success('保存成功');
        this.upFileList = []
        //刷新列表
        if (this.$refs['refContractAnnexes'])
          this.$refs['refContractAnnexes'].getList()
      }
      this.saveLoading = false
    },
  },
  created() {
    if (this.getToken()) {
      this.header = {
        'Authorization': 'Bearer ' + this.getToken()
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
    text-align: center;
}
</style>
